export default __webpack_public_path__ + "static/media/painscale_1.8a37314f.png";